import React from 'react';
import {browserHistory} from 'react-router';
import update from 'immutability-helper';
import {modal} from '../../../core/utilities/modal';

import {charge} from '../../../core/controllers/Charge';
import {tenant} from '../../../core/controllers/Tenant';
import TenantsSelect from '../TenantsSelect';

export default class ChargeEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chargeId: props.chargeId,
            newCharge: props.newCharge ? true : false,
            sortID: null,
            charge: {
                name: '',
                description: '',
                tenant_id: 0,
                amount: 0,
                length: 1,
                lengthUnit: "month",
                hasLease: null,
                oneOff: false
            },
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.state.newCharge) {
            charge.getCharge(this.state.chargeId,function(response) {
                const charge = response.data;
                self.updateTenantAndOneOff(charge.tenant_id);
                self.setState({
                    charge: {
                        name: charge.name,
                        description: charge.description,
                        tenant_id: charge.tenant_id,
                        amount: self.formatAmount(charge.charge / 100),
                        length: charge.how_many_months,
                        lengthUnit: "month",
                        oneOff: charge.oneOff
                    }
                });
            });
        }
        else {
            self.setState({
                hasLease: false
            });
        }
    }

    formatAmount(value) {
        value = value.toString();
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
        }

        return value;
    }

    chargeTenant() {
        if(!this.validateData()){
            return;
        }

        const chargeDetail = this.state.charge;
        var amount = this.state.charge.amount;
        var cleanedAmount = amount.toString();
        cleanedAmount = cleanedAmount.replace(',', '');
        const totalCharge = parseFloat(cleanedAmount);

        const length = chargeDetail.length;
        var lengthUnit = chargeDetail.lengthUnit;
        if (length > 1) {
            lengthUnit = lengthUnit + "s"
        }

        modal.showDangerModalWithOK("Are you sure?", "You are about to charge <b>$" + totalCharge + "</b> to this tenant, for a total of " + length + " " + lengthUnit + ".", "Yes, Charge!");
		jQuery(".move-on").on('click',function() {
            charge.chargeTenant(chargeDetail, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully Charged!', 'Charge has been applied to this tenant!');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    updateTenantAndOneOff(id) {
        var self = this;
        tenant.setTenantID(id);
        tenant.getTenant(this, function(responses) {
            var hasData = responses.data[0] != null
            var hasContract = responses.data[0].contract_data != null
            if(hasData && hasContract) {
                self.setState({
                    hasLease: true,
                    charge: update(self.state.charge, {
                        tenant_id: {$set: id},
                    })
                });
            }
            else {
                self.setState({
                    hasLease: false,
                    charge: update(self.state.charge, {
                        tenant_id: {$set: id},
                        oneOff: {$set: false},
                    })
                });
            }
        });
    }

    handleDeleteCharge() {
        const chargeId     = this.state.chargeId;
        modal.showDangerModalWithOK("Are you sure?", "You are about delete this charge and cancel all future charges", "Yes, Delete!");
		jQuery(".move-on").on('click',function() {
            charge.deleteCharge(chargeId, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully deleted!', 'Charge has been removed');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    handleUpdateCharge() {
        if(!this.validateData()){
            return;
        }

        const chargeDetail = this.state.charge;
        const chargeId     = this.state.chargeId;
        modal.showDangerModalWithOK("Are you sure?", "You are about update all future charges.  This will not update any current charges that are currently pending.", "Yes, Update!");
		jQuery(".move-on").on('click',function() {
            charge.updateCharge(chargeId, chargeDetail, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully Updated!', 'This charge was successfully updated!');
            });
        });
    }

    handleNameChange(e){
        this.setState({
            charge: update(this.state.charge, {
                name: {$set: e.target.value}
            })
        });
    }

    handleDescriptionChange(e){
        this.setState({
            charge: update(this.state.charge, {
                description: {$set: e.target.value}
            })
        });
    }

    handleAmountChange(e) {
        this.setState({
            charge: update(this.state.charge, {
                amount: {$set: e.target.value}
            })
        });
    }

    handleTenantChange(e) {
        var id = e.target.value;
        var self = this;
        if (id != 0) {
            self.updateTenantAndOneOff(id);
        }
        else {
            self.setState({
                charge: update(self.state.charge, {
                    tenant_id: {$set: id},
                })
            });
        }
    }

    handleLengthUnitChange(e) {
        this.setState({
            charge: update(this.state.charge, {
                lengthUnit: {$set: e.target.value}
            })
        });
    }

    handleLengthChange(e) {
        var value = e.target.value
        if (value == 1) {
            this.setState({
                charge: update(this.state.charge, {
                    length: {$set: value}
                })
            });
        }
        else {
            this.setState({
                charge: update(this.state.charge, {
                    length: {$set: value},
                    oneOff: {$set: false}
                })
            });
        }
    }

    handleOneOffChange(e) {
        var singlePayment = this.state.charge.length == 1
        var hasLease = this.state.hasLease
        if (!singlePayment) {
            modal.showInfo("Charge must be a single payment", "warning", "top", "center");
        }
        else if (hasLease == null || this.state.charge.tenant_id==0){
            modal.showInfo("Tenant must be selected", "warning", "top", "center");
        }
        else if (!hasLease) {
            modal.showInfo("Tenant must have a lease", "warning", "top", "center");
        }
        else if (singlePayment && hasLease) {
            this.setState({
                charge: update(this.state.charge, {
                    oneOff: {$set: !this.state.charge.oneOff}
                })
            })
        }
    }

    validateData() {
        const charge = this.state.charge;
        const name = charge.name;
        const description = charge.description;
        const tenant_id = charge.tenant_id;
        const amount = charge.amount.toString().replace(',', '').replace('.', '');
        const length = charge.length;
        const lengthUnit = charge.lengthUnit;

        if (name == null || name.length == 0) {
            modal.showInfo("Enter the charge name!", "warning", "top", "center");
            return false;
        } else if (description == null || description.length == 0) {
            modal.showInfo("Enter the charge description!", "warning", "top", "center");
            return false;
        } else if (tenant_id == 0) {
            modal.showInfo("Select a tenant to associate this charge with!", "warning", "top", "center");
            return false;
        } else if (amount == null || amount <= 0) {
            modal.showInfo("Enter the amount you want to charge this tenant!", "warning", "top", "center");
            return false;
        } else if(isNaN(amount)) {
            modal.showInfo("Enter a valid amount you want to charge this tenant.", "warning", "top", "center");
            return false;
        } else if (lengthUnit == null || lengthUnit == "0") {
            modal.showInfo("Select the length unit of this charge!", "warning", "top", "center");
            return false;
        } else if (length == null || length == 0) {
            modal.showInfo("Select the length of this charge!", "warning", "top", "center");
            return false;
        }

        return true;
    }

    buildLengthOptionsMenu() {
        var terms = [];
        for(var i = 1; i <= 31; i++) {
            terms.push(i);
        }
        for (var i = 36; i <= 72; i += 6) {
            terms.push(i)
        }

        return terms.map((term) => (
            <option key={'term-' + term} value={term}>{term}</option>
        ));
    }

    render(){
        const newCharge = this.props.newCharge;
        const chargeName = this.state.charge.name;
        const chargeDescription = this.state.charge.description;
        const chargeLength = this.state.charge.length;
        const chargeLengthUnit = this.state.charge.lengthUnit;
        const tenant_id = this.state.charge.tenant_id;
        const lengthOptions = this.buildLengthOptionsMenu();
        const oneOff = this.state.charge.oneOff;

        var chargeAmount = this.state.charge.amount;
        var cleanedAmount = chargeAmount.toString();
        cleanedAmount = cleanedAmount.replace(',', '');
        const totalCharge = parseFloat(cleanedAmount);

        var buttonText = 'Save Charge';
        if (newCharge) {
            if (!oneOff) {
                if (parseFloat(totalCharge) > 0) {
                    buttonText  = 'Charge $' + this.formatAmount(totalCharge) + ' to tenant';
                } else {
                    buttonText  = 'Charge';
                }
            }
            else {
                if (parseFloat(totalCharge) > 0) {
                    buttonText  = 'Charge $' + this.formatAmount(totalCharge) + ' to tenant at next rent invoice';
                } else {
                    buttonText  = 'Charge at next rent invoice';
                }
            }
        }

        return (
        <div>
        <div class="row blue-bottom-margin">
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        {newCharge ? (
                            <span class="sub-page-header-title">Charge Tenant</span>
                        ) : (
                            <span class="sub-page-header-title">{chargeName}</span>
                        )}
                    </div>
                </div>
            </div>
            <div class="col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 card">
                    <div class="header">
                        <h4 class="title">Charge Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <form>
                            <div class="row">
                                <div class="col-md-5 col-sm-6 col-xs-12">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" name="name" placeholder="Charge name" value={chargeName} onChange={this.handleNameChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <input type="text" class="form-control" name="description" placeholder="Charge description" value={chargeDescription} onChange={this.handleDescriptionChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12" style={{textAlign: "center"}}>
                                    <div class="tenant-charge-sentence col-md-2 col-sm-1 col-xs-4">
                                        Charge tenant
                                    </div>
                                    <div class="col-md-3 col-sm-3 col-xs-8">
                                        <div class="form-group has-feedback">
                                            <input type="text" value={chargeAmount} onChange={this.handleAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="How much is the charge amount?"/>
                                            <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="tenant-charge-sentence col-md-1 col-sm-1 col-xs-4">
                                            per
                                        </div>
                                        <div class="col-md-2 col-sm-3 col-xs-8">
                                            <select class="form-control text-underline" value={chargeLengthUnit} defaultValue="month" onChange={this.handleLengthUnitChange.bind(this)}>
                                                {/* <option key="week" value="week">week</option> */}
                                                <option key="month" value="month">month</option>
                                                {/* <option key="year" value="year">year</option> */}
                                            </select>
                                        </div>
                                        <div class="tenant-charge-sentence col-md-1 col-sm-1 col-xs-4">
                                            for
                                        </div>
                                        <div class="col-md-2 col-sm-2 col-xs-5">
                                            <select class="form-control text-underline" value={chargeLength} defaultValue="1" onChange={this.handleLengthChange.bind(this)}>
                                                {lengthOptions}
                                            </select>
                                        </div>
                                        <div class="tenant-charge-sentence col-md-1 col-sm-1 col-xs-3">
                                            {chargeLengthUnit}{chargeLength > 1 && "s"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12 col-xs-6">
                                    <label class="filter-checkbox-container">Add charge to next rent invoice
                                        <input class="filter-checkbox" type="checkbox" checked={oneOff} onClick={this.handleOneOffChange.bind(this)}/>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="header">
                                <h4 class="title"><i class="pe-7s-cash"></i> Tenant</h4>
                                <p class="category">Select a tenant to associate this charge with.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="content">
                                        <TenantsSelect title="" columnSize={12} sortID={tenant_id} onChange={this.handleTenantChange.bind(this)}/>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { newCharge ? (
        <div class="row blue-bottom">
            <div class="blue-bottom-center-align">
                <div class="col-md-12">
                    <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.chargeTenant.bind(this)}>
                    {buttonText}
                    </button>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        ) : (
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                        <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteCharge.bind(this)}>
                        Cancel Charge
                        </button>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateCharge.bind(this)}>
                        Update Charge
                        </button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        )}
        </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Tenants/Charge/ChargeEdit.jsx